import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid,
  Tooltip, ResponsiveContainer, Cell,
} from 'recharts'

const INDUSTRY_COLORS = {
  'Labor':          '#3B82F6',
  'Education':      '#8B5CF6',
  'Environment':    '#10B981',
  'Business':       '#F59E0B',
  'Energy':         '#EF4444',
  'Finance':        '#6366F1',
  'Political':      '#EC4899',
  'Technology':     '#06B6D4',
  'Veterans':       '#14B8A6',
  'Law Enforcement':'#64748B',
  'Healthcare':     '#F97316',
  'Grassroots':     '#22C55E',
  'Manufacturing':  '#A16207',
  'Political Reform':'#7C3AED',
}

function formatDollars(value) {
  if (value >= 1000000) return `$${(value / 1000000).toFixed(1)}M`
  if (value >= 1000)    return `$${(value / 1000).toFixed(0)}K`
  return `$${value}`
}

export default function InfluenceMap({ candidate }) {
  const { campaign_finance } = candidate
  if (!campaign_finance) return null

  const data = campaign_finance.top_donors.map(d => ({
    name:     d.name.length > 28 ? d.name.slice(0, 28) + '…' : d.name,
    amount:   d.amount,
    industry: d.industry,
  }))

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-civitas-navy">Campaign Finance — Top Donors</h3>
        <span className="badge bg-civitas-light text-civitas-blue text-xs">
          Total raised: {formatDollars(campaign_finance.total_raised)}
        </span>
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={data} layout="vertical" margin={{ left: 10, right: 30 }}>
          <CartesianGrid strokeDasharray="3 3" horizontal={false} />
          <XAxis type="number" tickFormatter={formatDollars} tick={{ fontSize: 11 }} />
          <YAxis type="category" dataKey="name" width={170} tick={{ fontSize: 11 }} />
          <Tooltip formatter={(v) => formatDollars(v)} contentStyle={{ fontSize: 12 }} />
          <Bar dataKey="amount" radius={[0, 4, 4, 0]}>
            {data.map((entry, i) => (
              <Cell key={i} fill={INDUSTRY_COLORS[entry.industry] ?? '#94A3B8'} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div className="mt-3 flex flex-wrap gap-2">
        {[...new Set(data.map(d => d.industry))].map(ind => (
          <span key={ind} className="flex items-center gap-1 text-xs text-gray-600">
            <span className="inline-block h-2 w-2 rounded-full" style={{ background: INDUSTRY_COLORS[ind] ?? '#94A3B8' }} />
            {ind}
          </span>
        ))}
      </div>
      <p className="mt-3 text-xs text-civitas-silver">
        Source: OpenFEC / VPAP. Data current as of filing period ending Q1 2026.
      </p>
    </div>
  )
}
